class Config {

    //dev
    static getMapKey(){
        return 'AIzaSyDOP-8tfaAZ8EKQVW-UMP7QLw_SCbyBgo4'
    }
    static getCreateDynamicLinkUrl(){
        return 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCPsEu47H0KRZpywBkNffYvM1shJHfNd8o'
    }
    static getLongDynamicLink(location){
        return 'https://lingmapsdev.page.link/?link='+location+'&ibi=com.tig-gis.Ling-Dev-642135&isi=1426315427&apn=com.gis.tig.ling.dev&efr=1'
    }
    static getCreateUserByEmailDocUrl(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/createUserByEmailDoc'
    }
    static getLineLoginWeb(){
        return 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1592830598&redirect_uri=https://ling-dev-123.firebaseapp.com/login&state=12345abcde&scope=openid%20profile&nonce=09876xyz'
    }
    static getLineIdTokenUrl(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/getLineIdToken'
    }
    static getVerifyLineTokenUrl(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/verifyLineToken'
    }
    static getMymapPageLink(){
        return 'https://ling-dev-123.firebaseapp.com/mymap'
    }
    static getResetPasswordPageLink(){
        return 'https://ling-dev-123.firebaseapp.com/resetpassword'
    }
    static getShortLinkReqeustUrl(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/generateShortLink'
    }
    static getGenerateCSVRequestUrl(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/generateCSV'
    }
    static getDisplaynameAndPhotoRequestURL(){
        return 'https://us-central1-ling-dev-123.cloudfunctions.net/getDisplaynameAndPhotoUrl'
    }

    //production
    // static getMapKey(){
    //     return 'AIzaSyAYyQlJuNs4gmYbBQOiq9hc0Z4_UIrmmdc'
    // }
    // static getCreateDynamicLinkUrl(){
    //     return 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDrD_bc_gv1tWfFhdRQwsDDdGAvZ3jFA10'
    // }
    // static getLongDynamicLink(location){
    //     return 'https://lingmaps.page.link/?link='+location+'&ibi=com.tig-gis.LandMeasure&isi=1147521441&apn=com.tig_gis.ling&efr=1'
    // }
    // static getCreateUserByEmailDocUrl(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/createUserByEmailDoc'
    // }
    // static getLineLoginWeb(){
    //     return 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1524124090&redirect_uri=https://lingmaps.com/login&state=12345abcde&scope=openid%20profile&nonce=09876xyz'
    // }
    // static getLineIdTokenUrl(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/getLineIdToken'
    // }
    // static getVerifyLineTokenUrl(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/verifyLineToken'
    // }
    // static getMymapPageLink(){
    //     return 'https://lingmaps.com/mymap'
    // }
    // static getResetPasswordPageLink(){
    //     return 'https://lingmaps.com/resetpassword'
    // }
    // static getShortLinkReqeustUrl(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/generateShortLink'
    // }
    // static getGenerateCSVRequestUrl(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/generateCSV'
    // }
    // static getDisplaynameAndPhotoRequestURL(){
    //     return 'https://us-central1-ling-156609.cloudfunctions.net/getDisplaynameAndPhotoUrl'
    // }
}

export default Config


// WEBPACK FOOTER //
// ./src/Configs/staticConfig.js